import Immutable from 'seamless-immutable'
import * as types from './types'

export const INITIAL_STATE = Immutable({
  fetching: false,
  received: false,
  list: [],
  pagination: {
    fetching: false,
    received: false,
    content: {
      currentPage: 1,
      lastPage: 1
    }
  },
  filters: {
    period: '',
    store_tab_numbers: '',
    partner_std_code: '',
    indicators: []
  },
  priorityMatrices: {
    fetching: false,
    content: []
  }
})

function mergeList(currentList, newList) {
  if (!currentList.length) {
    return newList
  }

  const lastItem = currentList.pop()

  if (lastItem.date === newList[0].date) {
    // eslint-disable-next-line no-param-reassign
    newList[0].events = [...lastItem.events, ...newList[0].events]

    return [...currentList, ...newList]
  }

  return [...currentList, lastItem, ...newList]
}

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FETCH_TIMELINE_LIST: {
      const newState = state
        .setIn(['fetching'], action.payload)
        .setIn(['receive'], !action.payload)

      return newState
    }

    case types.FETCH_TIMELINE_PAGINATION: {
      const newState = state
        .setIn(['pagination', 'fetching'], action.payload)
        .setIn(['pagination', 'receive'], !action.payload)

      return newState
    }

    case types.RECEIVE_TIMELINE_LIST: {
      const newdata = mergeList(
        action.payload.options.increment ? state.list.asMutable() : [],
        action.payload.data
      )

      const newState = state
        .setIn(['fetching'], false)
        .setIn(['receive'], true)
        .setIn(['list'], newdata)
      return newState
    }

    case types.RECEIVE_TIMELINE_LIST_METADATA: {
      const newState = state
        .setIn(['pagination', 'content'], action.payload)
        .setIn(['pagination', 'fetching'], false)

      return newState
    }

    case types.CLEAN_TIMELINE_LIST: {
      const newState = state
        .setIn(['data'], [])
        .setIn(['pagination', 'content'], [])

      return newState
    }

    case types.RECEIVE_TIMELINE_LIST_INCREASE: {
      const newState = state
        .setIn(['fetching'], false)
        .setIn(['receive'], true)
        .setIn(
          ['data'],
          [...mergeList(state.list.asMutable(), action.payload.data)]
        )

      return newState
    }

    case types.RECEIVE_TIMELINE_PAGINATION: {
      const newState = state
        .setIn(['pagination', 'fetching'], false)
        .setIn(['pagination', 'receive'], true)
        .setIn(['pagination', 'content'], action.payload)

      return newState
    }

    case types.POST_INTERATION: {
      return state.setIn(['fetching'], true)
    }

    case types.DONE_INTERATION: {
      return state
        .setIn(['fetching'], false)
        .setIn(['pagination', 'content'], [])
    }

    // Timeline filters

    case types.RECEIVE_TIMELINE_LIST_FILTERS: {
      const newState = state.merge(
        {
          filters: {
            page: INITIAL_STATE.filters.page,
            ...action.payload
          }
        },
        { deep: true }
      )

      return newState
    }

    case types.REMOVE_TIMELINE_LIST_FILTERS: {
      const filters = { ...state.filters }

      action.payload.forEach((filter) => {
        filters[filter] = INITIAL_STATE.filters[filter]
      })

      const newState = state.setIn(['filters'], filters)

      return newState
    }

    case types.RESET_TIMELINE_LIST_FILTERS: {
      const newState = state.setIn(['filters'], INITIAL_STATE.filters)

      return newState
    }

    case types.FETCH_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT: {
      const newState = state.setIn(
        ['priorityMatrices', 'fetching'],
        action.payload
      )
      return newState
    }

    case types.RECEIVE_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT: {
      const newState = state.setIn(
        ['priorityMatrices', 'content'],
        action.payload
      )

      return newState
    }

    case types.CLEAR_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT: {
      const newState = state.setIn(['priorityMatrices', 'content'], [])

      return newState
    }

    default: {
      return state
    }
  }
}

export default reducer
